import { render, staticRenderFns } from "./m-form-billing-tax-bill.vue?vue&type=template&id=a40ff0a8&scoped=true&lang=pug&"
import script from "./m-form-billing-tax-bill.vue?vue&type=script&lang=js&"
export * from "./m-form-billing-tax-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40ff0a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
